import {
    GET_DEVICE,
    GET_DEVICE_SUCCESS,
    GET_DEVICE_FAILURE,
    SSID,
    SSID_SUCCESS,
    SSID_FAILURE,
    PASSWORD,
    PASSWORD_SUCCESS,
    PASSWORD_FAILURE,
    REBOOT,
    REBOOT_SUCCESS,
    REBOOT_FAILURE,
    RESET,
    RESET_SUCCESS,
    RESET_FAILURE,
} from './actionTypes';
import { DeviceState, DeviceActions } from './types';

const initialState: DeviceState = {
    getDevice: [],
    errorGetDevice: null,
    isGetDeviceLoaded: false,
    SuccessSsid: [],
    errorSsid: null,
    isSsidLoaded: false,
    SuccessPassword: [],
    errorPassword: null,
    isPasswordLoaded: false,
    SuccessReboot: [],
    errorReboot: null,
    isRebootLoaded: false,
    SuccessReset: [],
    errorReset: null,
    isResetLoaded: false,
};

export default (state = initialState, action: DeviceActions) => {
    switch (action.type) {
        case GET_DEVICE:
            return {
                ...state,
                isGetDeviceLoaded: true,
            };
        case GET_DEVICE_SUCCESS:
            return {
                ...state,
                getDevice: action.payload.getDevice,
                errorGetDevice: null,
                isGetDeviceLoaded: false,
            };
        case GET_DEVICE_FAILURE:
            return {
                ...state,
                getDevice: [],
                errorGetDevice: action.payload.errorGetDevice,
                isGetDeviceLoaded: false,
            };
        case SSID:
            return {
                ...state,
                isSsidLoaded: true,
            };
        case SSID_SUCCESS:
            return {
                ...state,
                SuccessSsid: action.payload.SuccessSsid,
                errorSsid: null,
                isSsidLoaded: false,
            };
        case SSID_FAILURE:
            return {
                ...state,
                SuccessSsid: [],
                errorSsid: action.payload.errorSsid,
                isSsidLoaded: false,
            };
        case PASSWORD:
            return {
                ...state,
                isPasswordLoaded: true,
            };
        case PASSWORD_SUCCESS:
            return {
                ...state,
                SuccessPassword: action.payload.SuccessPassword,
                errorPassword: null,
                isPasswordLoaded: false,
            };
        case PASSWORD_FAILURE:
            return {
                ...state,
                SuccessPassword: [],
                errorPassword: action.payload.errorPassword,
                isPasswordLoaded: false,
            };
        case REBOOT:
            return {
                ...state,
                isRebootLoaded: true,
            };
        case REBOOT_SUCCESS:
            return {
                ...state,
                SuccessReboot: action.payload.SuccessReboot,
                errorReboot: null,
                isRebootLoaded: false,
            };
        case REBOOT_FAILURE:
            return {
                ...state,
                SuccessReboot: [],
                errorReboot: action.payload.errorReboot,
                isRebootLoaded: false,
            };
        case RESET:
            return {
                ...state,
                isResetLoaded: true,
            };
        case RESET_SUCCESS:
            return {
                ...state,
                SuccessReset: action.payload.SuccessReset,
                errorReset: null,
                isResetLoaded: false,
            };
        case RESET_FAILURE:
            return {
                ...state,
                SuccessReset: [],
                errorReset: action.payload.errorReset,
                isResetLoaded: false,
            };

        default:
            return {
                ...state,
            };
    }
};
